import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <FAQSection />
        <MediaSection />
        <FeaturesSection />
        <UpdatesSection />
        <CardsSection />
        <CommentsSection />
        <ContactSection />
        <RankingSection />
        <AboutSection />
        <CarouselSection />
        <IndexSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}